import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { first, Observable, of, switchMap } from 'rxjs';
import { HlDisplayPortalFeaturesService } from './hl-display-portal-features.service';
import { Customer } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class HlDisplayFreightService {
  constructor(
    protected http: HttpClient,
    protected portalFeatureSettings: HlDisplayPortalFeaturesService
  ) { }

  getCustomFreight(customer: Customer): Observable<HLDisplayCustomFreight> {
    const baseUrl = 'json/hl-display/get-freight-levels';

    const portalName = this.portalFeatureSettings.getPortalName();

    const url = `${baseUrl}/${portalName}/${customer.id}`;

    return this.http.get(url).pipe(
      switchMap((response: HLDisplayCustomFreight) => {
        // If the response is not empty, return the response
        if (response && response.freightLevels?.length > 0) {
          return of(response);
        } else {
          return of(null);
        }
      })
    );
  }
}

export interface HLDisplayCustomFreight {
  descriptionTranslateTag: string;
  freightLevels: HLDisplayCustomFreightLevel[];
}

export interface HLDisplayCustomFreightLevel {
  freightCost: number;
  upperLevelLimit: number;
  currency: string;
}
